<template>
  <NuxtLayout name="user">
    <Stepper
      class="mb-10 self-center"
      :current-step="routeSteps[$route.path]"
      :steps="[
        'Verification & Profile Type',
        'Profile Info',
        'Company Verifications',
        'Cuisine Type',
      ]"
    />

    <slot />
  </NuxtLayout>
</template>

<script lang="ts" setup>
import Stepper from "~/components/common/Molecule/Stepper.vue";
import paths from "~/constants/paths";

const isRegistering = ref(false);
const route = useRoute();
const user = useCookie("hs-token");

const routeSteps = {
  [paths.b2b.register.company.info]: 1,
  [paths.b2b.register.company.verification]: 2,
  [paths.b2b.register.company.type]: 3,
};

// FIXME: Manual watcher to avoid returning to auth steps after registering when refreshing
watch(
  route,
  (newRoute) => {
    if (newRoute.path === paths.b2b.register.company.info) {
      isRegistering.value = true;
    } else if (
      newRoute.path.includes(paths.b2b.register.index) &&
      user.value &&
      !isRegistering.value
    ) {
      navigateTo(paths.home);
    }
  },
  { immediate: true },
);
</script>
